import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import numeral from 'numeral';

import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  makeStyles,
  useTheme
} from '@material-ui/core';

import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LogarithmicScale,
  LineElement
} from 'chart.js';

ChartJS.register(
  PointElement,
  LineElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels,
  LogarithmicScale
);

import { Bar } from 'react-chartjs-2';
import { Doughnut } from 'react-chartjs-2';

import NewsIcon from '@material-ui/icons/NotificationsActive';
import SolvingIcon from '@material-ui/icons/DirectionsRun';
import SolvedIcon from '@material-ui/icons/NotificationsOff';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%'
  }
}));

const Situation = ({ className, ...rest }) => {

  const classes = useStyles();
  const theme = useTheme();

  const options = {
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    legend: {
      display: false
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.default,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'index',
      titleFontColor: theme.palette.text.primary
    }
  };

  const data = {
    datasets: [
      {
        data: [rest.news, rest.solving, rest.resolveds],
        backgroundColor: [
          colors.red[600],
          colors.yellow[900],
          colors.green[600]
        ],
        borderWidth: 8,
        borderColor: colors.common.white,
        hoverBorderColor: colors.common.white
      }
    ],
    labels: ['Novo', 'Em Tratamento', 'Resolvido']
  };

  const alerts = [
    {
      title: 'Novo',
      value: numeral(rest.news / rest.total).format('0%'),
      icon: NewsIcon,
      color: colors.red[600]
    },
    {
      title: 'Em Tratamento',
      value: numeral(rest.solving / rest.total).format('0%'),
      icon: SolvingIcon,
      color: colors.yellow[900]
    },
    {
      title: 'Resolvido',
      value: numeral(rest.resolveds / rest.total).format('0%'),
      icon: SolvedIcon,
      color: colors.green[600]
    }
  ];

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardHeader title="Situação dos Alarmes" />
      <Divider />
      <CardContent>
        <Box
          height={300}
          position="relative"
        >
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          mt={2}
        >
          {alerts.map(({
            color,
            icon: Icon,
            title,
            value
          }) => (
            <Box
              key={title}
              p={1}
              textAlign="center">
              <Icon color="action" />
              <Typography
                color="textPrimary"
                variant="caption"
              >
                {title}
              </Typography>
              <Typography
                style={{ color }}
                variant="h5"
              >
                {value}
              </Typography>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

Situation.propTypes = {
  className: PropTypes.string
};

export default Situation;